import { API_VERSION } from '@/apis/constants';
import { GetReportCfvEmissionsDataEntryRes } from '@/apis/report/cfv/emissions/data-entry.dto';
import { Api } from '@/typings/api';
import { ApiMethod, ApiService, buildUrl } from '@/utils/api';
import Request from '@/utils/Request';

import {
  GetReportCfvEmissionsDataApprovalParams,
  // [PLOP ANCHOR] dtoImport
} from './data-approval.dto';

const request = Request.getInstance().request;

export const getReportCfvEmissionsDataApprovalUrl = () =>
  buildUrl({
    service: ApiService.REPORT,
    version: API_VERSION[ApiService.REPORT],
    path: `/cfv/emissions/data_approval`,
  });
// [PLOP ANCHOR] apisUrl

export const getReportCfvEmissionsDataApproval: Api<
  GetReportCfvEmissionsDataApprovalParams,
  GetReportCfvEmissionsDataEntryRes
> = (payload) =>
  request({
    url: getReportCfvEmissionsDataApprovalUrl(),
    method: ApiMethod.GET,
    params: payload.query,
  });

// [PLOP ANCHOR] apisDefinition
